import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/processes/$processInstanceId/task/$taskId/')({
  validateSearch: (search: Record<string, unknown>) => ({
    responseToken: search.responseToken as string | undefined,
  }),
  beforeLoad: ({ search, params }) => {
    if (search.responseToken) {
      throw redirect({
        to: '/processes/$processInstanceId/task/$taskId/payment',
        params: { processInstanceId: params.processInstanceId, taskId: params.taskId },
      });
    }
  },
  head: () => {
    return {
      meta: [
        {
          title: 'Application Form - OPAZ E-Service Portal',
        },
      ],
    };
  },
});
